import React from "react";
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

class TablePaginationActions extends React.Component {

    handleFirstPageButtonClick = e => this.props.onChangePage(e, 0);

    handleBackButtonClick = e => this.props.onChangePage(e, this.props.page - 1);

    handleNextButtonClick = e => this.props.onChangePage(e, this.props.page + 1);

    handleLastPageButtonClick = e => this.props.onChangePage(e, Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));

    render() {
        const { count, page, rowsPerPage } = this.props;

        return (
            <div className="table-pagination">
                <IconButton onClick={this.handleFirstPageButtonClick}
                            disabled={page === 0} >
                    <FirstPageIcon />
                </IconButton>
                <IconButton onClick={this.handleBackButtonClick}
                            disabled={page === 0} >
                    <KeyboardArrowLeft />
                </IconButton>
                <IconButton onClick={this.handleNextButtonClick}
                            disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
                    <KeyboardArrowRight />
                </IconButton>
                <IconButton onClick={this.handleLastPageButtonClick}
                            disabled={page >= Math.ceil(count / rowsPerPage) - 1} >
                    <LastPageIcon />
                </IconButton>
          </div>
    );
  }
};

export default TablePaginationActions;



// WEBPACK FOOTER //
// ./src/components/TablePaginationActions.js